<form [formGroup]="filterForm">
  <mat-form-field
    subscriptSizing="dynamic"
    appearance="outline"
    class="form-field"
  >
    <mat-label>{{ label }}</mat-label>
    <mat-select [formControlName]="controlName" [(value)]="selectedValue">
      @for (filterItem of filterItems; track filterItem) {
        <mat-option [value]="filterItem">
          {{ filterItem }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
